import { ArrowLeftColor, SharedInput } from "@components";
import { selectApp, selectAuth, selectMerchant } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { RenderMeta, useNotify } from "@utils";
import { Button } from "antd";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import axiosClient from "../API/axiosClient";

export const PageVirtualMedical = () => {
    const { userInfo } = useSelector(selectAuth);
    const [nationalID, setNationalID] = useState<string>();
    const [isCheck, setIsCheck] = useState<boolean>(true);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { langSetting } = useSelector(selectApp);
    const { error } = useNotify();
    const history = useHistory();

    const getVirtualMedical = async () => {
        UIStore.setState({ isLoading: true });
        try {
            const get = await axiosClient.get("/contacts/url-samitivej");
            if (get.data?.url) {
                window.open(get.data?.url, "_blank");
                history.push("/");
            }
            setIsCheck(false);
            UIStore.setState({ isLoading: false });
        } catch (err: any) {
            setIsCheck(false);
            UIStore.setState({ isLoading: false });
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        }
    };

    const sendVirtualMedical = async () => {
        try {
            const get = await axiosClient.get("/contacts/url-samitivej?nationalId=" + nationalID);
            if (get.data?.url) {
                window.open(get.data?.url, "_blank");
                history.push("/");
            }
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        }
    };

    useEffect(() => {
        getVirtualMedical();
        if (!userInfo) {
            history.push("/");
        }
    }, []);

    return isCheck ? (
        <></>
    ) : (
        <StyledContainer mainColor={themes?.themeColor!}>
            <RenderMeta title={t("meta.virtualmedical_page")} />
            <div className="backIcon" onClick={() => history.push("/")}>
                <ArrowLeftColor color={themes?.themeColor} />
                {/* <span>{t("page.back")}</span> */}
            </div>
            {/* <p className="title">National ID</p> */}
            <div className="content">
                <SharedInput
                    placeholder="National ID"
                    name="nationalid"
                    onChange={(e: any) => setNationalID(e.target.value)}
                />
            </div>
            <div className="btn-section">
                <Button
                    className="btn confirm"
                    onClick={() => sendVirtualMedical()}
                    // disabled={isProcessing}
                >
                    Confirm
                </Button>
            </div>
        </StyledContainer>
    );
};
const StyledContainer = styled.div<{ mainColor: string }>`
    position: relative;
    padding: 11px;
    background-color: #fff;
    color: #676767;
    text-align: start;
    font-weight: normal;
    font-size: 20px;
    line-height: 27px;
    .day {
        margin-bottom: 27px;
        border-radius: 6px;
        .title {
            font-size: 16px;
            color: #676767;
        }
    }
    .gender,
    .email {
        border-radius: 6px;

        .title {
            font-size: 16px;
            color: #676767;
        }
        .ant-radio-checked {
            .ant-radio-inner {
                border-color: ${(p) => p.mainColor};
                background-color: ${(p) => p.mainColor};
            }
        }
    }
    .bottom {
        width: fit-content;
        margin: 0 auto;
        margin-top: 5rem;
        text-align: center;
        span {
            font-weight: normal;
            font-size: 16px;
            line-height: 21px;
            color: #676767;
        }
        /* .ant-checkbox-wrapper {
            display: block;
        } */
    }
    .ant-select-selection {
        /* border-color: gray !important; */
        box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        border-radius: 6px;
        border: 1px solid lightgray;
    }
    input {
        background-color: white !important;
        border: 1px solid lightgray;
    }

    input[type="search"] {
        background-color: transparent !important;
    }

    .intl-tel-input input {
        border-radius: 6px;
    }
    .term-field {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }
    .cross-line {
        background-color: #f1f1f1;
        height: 15px;
        margin-top: 40px;
    }

    .ant-select-arrow {
        color: ${(p) => p.mainColor} !important;

        stroke-width: 50px;
        stroke: ${(p) => p.mainColor};
    }

    .ant-checkbox-inner {
        border-color: ${(p) => p.mainColor};
    }
    :hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
        background-color: ${(p) => p.mainColor} !important;
    }
    :not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
    :where(.css-dev-only-do-not-override-1kuana8).ant-checkbox:not(.ant-checkbox-disabled):hover
        .ant-checkbox-inner {
        border-color: ${(p) => p.mainColor};
    }
    .content {
        margin: 30px 0;
    }
    .btn-section {
        width: 100%;
        position: relative;
        padding: 15px 0;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
            span {
                font-weight: 600;
            }
        }
        .back {
            border: 1px solid ${(p) => p.mainColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.mainColor};
            color: white;
            background-color: ${(p) => p.mainColor};
        }
    }
    .backIcon {
        padding: 20px 0;
        cursor: pointer;
        z-index: 1;
        display: flex;
        align-items: center;
        span {
            font-size: 14px;
            line-height: 17px;
            margin-left: 10px;
            color: ${(p) => p.mainColor};
        }
    }
    .button {
        margin-top: 20px;
        width: 100%;
    }
    .title {
        margin-top: 100px;
    }
`;
